<template>
    <div class="mb-1 mb-lg-2 pl-lg-3">
        <form id="form--product-search" @submit.prevent="searchProducts">
            <span class="input-wrapper">
                <i class="fa fa-search" aria-hidden="true"></i>
                <input type="search" v-model="search" value="">
            </span>            
            <input
                type="submit"
                class="btn--orange"
                :class="{disabled: isDisabled}"
                :disabled="isDisabled"
                :value="buttonText">
        </form>
    </div>
</template>
<script>
import { FilterType } from '../@types/Filters'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            search: ""
        }
    },
    computed : {
        isDisabled() {
            let active = false;

            this.getFilters().forEach(term => {
                if (term.handle === "s" && term.value === this.search) {
                    active = true;
                }   
            })

            return active            
        },
        buttonText() {
          return TG.vue.labels.buttons.search || "Search"
        }
    },
    methods : {
        ...mapActions(['addFilter']),
        ...mapGetters(['getFilters']),
        searchProducts() {
            if (this.search != "") {
                this.addFilter({
                    type: FilterType.Meta,
                    name : this.search,
                    handle: 's',
                    value: this.search
                })
            }
        }
    }
}
</script>
<style lang="scss">
    #form--product-search {
        display: flex;
        width: 100%;

        input[type="submit"] {
            flex: 0 0 auto;

            &.disabled {
                opacity: .5;
            }
        }
        .input-wrapper {
            display: flex;
            flex: 1 1 100%;
            max-width: 100%;
            margin-right: .5rem;
            align-items: center;

            i {
                flex: 0 0 auto;
            }
            input {
                margin-left: .5rem;
                flex: 1 1 100%;
                line-height: 1;
            }
        }
    }
</style>